module.exports = __webpack_public_path__ + "static/media/cleaning.966f44e1.svg";